import i18next from 'i18next'

export const getLoginStatusMessage = (errorCode) => {
    switch (errorCode) {
        case 200:
            return i18next.t('login.welcome')
        case 400:
        case 401:
        case 403:
        case 422:
            return i18next.t("login.email and password don't match")
        case 500:
            return i18next.t('login.something went wrong on our end, please try again later')
        default:
            return ''
    }
}

export const getSignupStatusMessage = (errorCode) => {
    switch (errorCode) {
        case 200:
        case 201:
            return i18next.t('login.welcome')
        case 401:
        case 403:
            return i18next.t('login.email has already been taken')
        case 422:
            return i18next.t('login.email address or password is invalid')
        case 500:
            return i18next.t('login.something went wrong on our end, please try again later')
        default:
            return ''
    }
}
